var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 0C17.6642 0 18 0.335786 18 0.75V3H21.25C22.7688 3 24 4.23122 24 5.75V21.25C24 22.7688 22.7688 24 21.25 24H2.75C1.23122 24 0 22.7688 0 21.25V5.75C0 4.23122 1.23122 3 2.75 3H6V0.75C6 0.335786 6.33579 0 6.75 0C7.16421 0 7.5 0.335786 7.5 0.75V3H16.5V0.75C16.5 0.335786 16.8358 0 17.25 0ZM6 4.5V6C6 6.41421 6.33579 6.75 6.75 6.75C7.16421 6.75 7.5 6.41421 7.5 6V4.5H16.5V6C16.5 6.41421 16.8358 6.75 17.25 6.75C17.6642 6.75 18 6.41421 18 6V4.5H21.25C21.9404 4.5 22.5 5.05964 22.5 5.75V9H1.5V5.75C1.5 5.05964 2.05964 4.5 2.75 4.5H6ZM1.5 10.5H22.5V21.25C22.5 21.9404 21.9404 22.5 21.25 22.5H2.75C2.05964 22.5 1.5 21.9404 1.5 21.25V10.5ZM17.0303 14.0303C17.3232 13.7374 17.3232 13.2626 17.0303 12.9697C16.7374 12.6768 16.2626 12.6768 15.9697 12.9697L11.25 17.6893L8.78033 15.2197C8.48744 14.9268 8.01256 14.9268 7.71967 15.2197C7.42678 15.5126 7.42678 15.9874 7.71967 16.2803L10.7197 19.2803C11.0126 19.5732 11.4874 19.5732 11.7803 19.2803L17.0303 14.0303Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCalendar);
export default __webpack_public_path__ + "static/media/event-calendar.0a54733dabcfb13149f56fa04f765ffa.svg";
export { ForwardRef as ReactComponent };